import { greyScale, colorScale } from 'themes/defaultColors';

// data visualization
const cobalt = '#1a488d';
const oceanBlue = '#006fb3';
const cerulean = '#0096ca';
const turquoiseBlue = '#00bdcf';
const aquamarine = '#00e1c7';
const dullYellow = '#ecdc5f';
const paleOrange = '#ffb957';
const orangish = '#ef7d5b';
const pastelRed = '#da6561';
const lightBurgundy = '#b13650';
const warmPurple = '#862f69';
const darkSlateBlue = '#3b205c';
const amber = '#EAA111';
const red = '#DC3B3B';
const green = '#34AB3C';

const cobaltGrad = `linear-gradient(180deg, ${cobalt} 0%, #000B50 100%)`;
const oceanBlueGrad = `linear-gradient(180deg, ${oceanBlue} 0%, #003175 100%)`;
const ceruleanGrad = `linear-gradient(180deg, ${cerulean} 0%, #00598D 100%)`;
const turquoiseBlueGrad = `linear-gradient(180deg, ${turquoiseBlue} 0%, #008092 100%)`;
const aquamarineGrad = `linear-gradient(180deg, ${aquamarine} 0%, #00A48A 100%)`;
const dullYellowGrad = `linear-gradient(180deg, ${dullYellow} 0%, #AF9F22 100%)`;
const paleOrangeGrad = `linear-gradient(180deg, ${paleOrange} 0%, #C27C1A 100%)`;
const orangishGrad = `linear-gradient(180deg, ${orangish} 0%, #B2401E 100%)`;
const pastelRedGrad = `linear-gradient(180deg, ${pastelRed} 0%, #9D2824 100%)`;
const lightBurgundyGrad = `linear-gradient(180deg, ${lightBurgundy} 0%, #730012 100%)`;
const warmPurpleGrad = `linear-gradient(180deg, ${warmPurple} 0%, #49002C 100%)`;
const darkSlateBlueGrad = `linear-gradient(180deg, ${darkSlateBlue} 0%, #150036 100%)`;
const amberGrad = `linear-gradient(180deg, #FFD444 0%, ${amber} 100%)`;
const redGrad = `linear-gradient(180deg, #FF6E6E 0%, ${red} 100%)`;
const greenGrad = `linear-gradient(180deg, #67DE6F 0%, ${green} 100%)`;

// new palette
// -------------------------
// COLOR SCALE

const colors = {
  primary: { // this is the color of selection
    light: colorScale.color1.opacity50,
    main: colorScale.others.link,
    dark: colorScale.others.linkDark,
  },
  secondary: { // color of buttons (mostly, but others stuff too)
    light: colorScale.color1.opacity50,
    main: colorScale.others.link,
    dark: colorScale.others.linkDark,
  },
  error: {
    main: colorScale.others.negative,
  },
  text: {
    primary: '#333333',
    secondary: '#707070',
    disabled: '#c9c7c5',
    lightContrast: greyScale[7],
  },
  other: {
    quickTips: '#ef7d5b',
    dueTxn: '#f29d50',
  },
};

// -- THIS EXPORT SHOULD NOT BE USED EXCEPT IN 'theme.js' -- //
export const theme = {
  project: 'Simplifi',
  defaults: {},
  typography: {
    fontFamily: [
      'Rubik',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
      '"Segoe UI"',
      '-apple-system',
      'BlinkMacSystemFont',
    ].join(','),
    h5: {
      fontSize: 26,
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 18,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 16,
    },
  },
  palette: {
    ...colors,
    ...colorScale,
    data: {
      sequence1: [colorScale.color1.opacity100, colorScale.color2.opacity100, colorScale.color3.opacity100, colorScale.color4.opacity100,
        colorScale.color5.opacity100, colorScale.color6.opacity100, colorScale.color7.opacity100, colorScale.color8.opacity100, colorScale.color9.opacity100],

      sequence2: [colorScale.color8.opacity100, colorScale.color4.opacity100, colorScale.color9.opacity100, colorScale.color1.opacity100,
        colorScale.color5.opacity100, colorScale.color6.opacity100, colorScale.color3.opacity100, colorScale.color2.opacity100,
        colorScale.color7.opacity100, colorScale.others.link, colorScale.others.cool4, colorScale.color8.opacity100],

      gradients: {redGrad, greenGrad, amberGrad, pastelRedGrad, orangishGrad, paleOrangeGrad, dullYellowGrad, aquamarineGrad, turquoiseBlueGrad,
        ceruleanGrad, oceanBlueGrad, cobaltGrad, darkSlateBlueGrad, warmPurpleGrad, lightBurgundyGrad},
    },
    //  TEMPORARY
    background: {
      default: greyScale[7],
    },

  },
  // override specific component styles for ACME theme, colors should be referenced from the 'colors' object above,
  //    ----- ONLY in special cases should there be hex codes below here -----
  components: {
    appBar: {
      color: colors.text.primary,
      borderRadius: 0,
      opacity: 1,
      borderBottom: `1px solid ${colorScale.color1.opacity30}`,
      background: greyScale[7],
      boxShadow: 'none',
      zIndex: 12,
      height: 75,
      minHeight: 75,
      position: 'sticky',
      display:'flex',
    },
    toolBar: {
      height: 75,
      minHeight: 75,
      paddingLeft: 32,
      paddingRight: 32,
      width:'100%',
      display:'flex',
      justifyContent:'space-between',
    },
    featureHeader: {
      titleVariant: 'h6',
      subTitleVariant: 'subtitle1',
    },
    register: {
      transferDelimeter1: '',
      transferDelimeter2: '',
      fieldMargin: 16,

      pendingTextColor: null,
      pendingRowColor: greyScale[7],
    },
    accountCard: {
      background: colorScale.color8.opacity100,
    },
    accountDrawer:{
      // -- Sizing -- //
      width: 292,
      accountListBaseFontSize: 16,
      drawerListTitleFontSize: 20,

      basePadding: 32,
      listPaddingLeft: 46,
      listPaddingRight: 32,

      accountListLevelIndent: 0,
      iconSize: 18,

      // -- Text colors -- //
      // positiveBalance: null,
      highlightText: colors.text.primary, // total + net-worth
      textColor: colors.text.primary, // banking + investments
      headerListText: colors.text.primary, // accounts bar
      l2TextColor: colors.text.primary,
      l3TextColor: colors.text.secondary,
      negativeBalance: colorScale.others.negative,

      // -- Background colors -- //
      background: greyScale[7],
      highlightColor: colorScale.color1.opacity30, // selected account
      hoverColor: colorScale.color1.opacity30, // hover effect
      l1Color: colorScale.color7.opacity30, // banking + investments
      logoBackground: 'transparent',
      headerBackground: greyScale[7],

      // other colors
      borderColor: greyScale[4], // right-side border
      divider: greyScale[4], // border of collapse button
      openControl: greyScale[5],  // background inside collapse button,
      icon: greyScale[2],  // icon inside collapse button,

      actionColor: greyScale[7], // add-FI button color
      actionBackground: colorScale.others.link, // add-FI button background
      actionButtonSize: 36,

      // row sizing
      l1Margin: '8px 0 0',
      l0Height: 52,
      l1Height: 40,
      l2Height: 40,
      l3Height: 32,

      addFiLabel: 'ADD',
    },
    navigation: {
      headerColor: greyScale[7],
      barWidthOpen: 230,
      rowOpacity: 1,
      selectedBackground: colorScale.color1.opacity100,
      hoverBackground: colorScale.color1.opacity30,
      iconColor: colorScale.color8.opacity70,
      selectedIconColor: greyScale[7],
      iconHoverColor: colorScale.color8.opacity100,
      textColor: '#333',
      selectedTextColor: greyScale[7],
    },
    spendingOverTime: {
      positiveDefault: colorScale.color1.opacity100,
      positiveDimmed: colorScale.color1.opacity30,
      negativeDefault: colorScale.color1.opacity100,
      negativeDimmed: colorScale.color1.opacity30,
    },
    incomeVersusSpending: {
      spendingPositiveDefault: colorScale.color1.opacity100,
      spendingPositiveDimmed: colorScale.color1.opacity30,
      spendingNegativeDefault: colorScale.color1.opacity100,
      spendingNegativeDimmed: colorScale.color1.opacity30,

      incomePositiveDefault: colorScale.color9.opacity100,
      incomePositiveDimmed: colorScale.color9.opacity30,
      incomeNegativeDefault: colorScale.color9.opacity100,
      incomeNegativeDimmed: colorScale.color9.opacity30,
    },
    spendingWatchlist: {
      detailsBackgroundColor: '#0049a3',
    },
    netIncome: {
      positiveDefault: colorScale.color9.opacity100,
      positiveDimmed: colorScale.color9.opacity30,
      negativeDefault: colorScale.color9.opacity100,
      negativeDimmed: colorScale.color9.opacity30,
    },
    income: {
      positiveDefault: colorScale.color9.opacity100,
      positiveDimmed: colorScale.color9.opacity30,
      negativeDefault: colorScale.color9.opacity100,
      negativeDimmed: colorScale.color9.opacity30,
    },
    qCards: {
      backgroundColor: '#085c8c',
      titleColor: greyScale[7],
      contentColor: greyScale[7],
      closeColor: greyScale[7],
      highlightColor: '#ca059f',
    },
    savingGoals: {
      borderColor: '#ffb957',
      zeroStateBg: '#dce3f6',
      selectBorderColor: '#ecebea',
    },
    reports: {
      graphHeight: 280,
    },
    errorBanner: {
      borderLeftColor: orangish,
      width: '100%',
      height: 98,
      display:'flex',
      borderLeftStyle: 'solid',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
};
